import { render } from "./Button.vue?vue&type=template&id=c1631092&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=c1631092&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Documents\\eChook\\Code\\gpt-nano-configurator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1631092"]])

export default __exports__